import { useRouter } from '@/hooks/useRouter';

export const useHostingType = () => {
  const router = useRouter();
  const isRentalAuto = router.pathname === '/become-a-host/auto';

  return { isRentalAuto };
};
